import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const individualContentGraphApi = createAsyncThunk(
    'auth/IndividualContentGraph/graph',
    async (requestData, { rejectWithValue }) => {
        try {
            const { type, params } = requestData;
            const response = await AuthAxios.get(apiRoutes.individualContentGraph(`${type}`), { params })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const individualContentGraphSlice = createSlice({
    name: 'IndividualContentGraph/graph',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetIndividualContentGraph: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(individualContentGraphApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(individualContentGraphApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(individualContentGraphApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetIndividualContentGraph } = individualContentGraphSlice.actions;
export const individualContentGraphReducer = individualContentGraphSlice.reducer